// extracted by mini-css-extract-plugin
export default {"content":"LoginPage_content__SNpqL","footer":"LoginPage_footer__f+DAu","loginBtn":"LoginPage_loginBtn__zrowW","userAuthLayout":"LoginPage_userAuthLayout__bTv-2"};